"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CareTeamParticipant = void 0;
/**
 * The Care Team includes all the people and organizations who plan to participate in the coordination and delivery of care for a patient.
 */
var CareTeamParticipant = /** @class */ (function () {
    function CareTeamParticipant() {
    }
    return CareTeamParticipant;
}());
exports.CareTeamParticipant = CareTeamParticipant;
